export default __webpack_public_path__ + "static/media/gallery-wip-handle_00.283639a1.jpg";